import { Component, effect, inject, ViewChild } from '@angular/core';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../content.error';
import { ServiceSettingsSickNotesStore } from './service-settings-sick-notes.store';
import { SERVICE_SETTINGS_SICK_NOTES_TYPE_KEY } from '@libs/types/src/services/types/service-settings-sick-notes.type';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Divider } from '@openng/optimus-ui/divider';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import {
    ServiceDoctorsSecretsComponent,
} from '../../../../../../components/medical-service/service/settings/service-doctors-secrets/service-doctors-secrets.component';
import {
    ServiceCertificatesSettingsComponent,
} from '../../../../../../components/medical-service/service/settings/service-certificates-settings/service-certificates-settings.component';

@Component({
    selector: 'app-service-settings-sick-notes',
    templateUrl: './service-settings-sick-notes.component.html',
    styleUrl: './service-settings-sick-notes.component.scss',
    providers: [ServiceSettingsSickNotesStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        TextInputComponent,
        ActionButtonsComponent,
        ServiceDoctorsSecretsComponent,
        ServiceCertificatesSettingsComponent,
    ],
})
export class ServiceSettingsSickNotesComponent {
    public readonly store = inject(ServiceSettingsSickNotesStore);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);

    @ViewChild(ServiceSettingsCommonComponent)
    serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({
        icpe: fb.control<string | null>(null),
    });

    constructor() {
        effect(() => {
            const defaultValues = this.store.sickNotesSettings();
            if (defaultValues) {
                this.form.patchValue({
                    icpe: defaultValues?.icpe || '',
                });
            }
        });
    }

    async save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            ...JSON.parse(this.serviceSettingsCommonComponent.getFormData()),
            icpe: this.form.value.icpe,
        };

        this.store.api
            .updateServiceSettings({
                key: SERVICE_SETTINGS_SICK_NOTES_TYPE_KEY,
                data: JSON.stringify(data),
                serviceId: Number(serviceId),
            })
            .then(() => {
                contentGlobalSuccess.next('common.updated');
            });
    }

    protected async cancel(): Promise<void> {
        await this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }

    protected readonly routeParams = routeParams;
    protected readonly Number = Number;
    protected readonly UserSecretTypeEnum = UserSecretTypeEnum;
}
